import clsx from "clsx";
import React from "react";

interface HeadlineProps {
  normal?: string;
  bold?: string;
  reverse?: boolean;
  forceLeft?: boolean;
  breakAfter?: boolean;
  level?: string;
  as?: string;
  className?: string;
  dataAos?: string;
  dataAosDelay?: number;
}

export const Headline: React.FC<HeadlineProps> = ({
  bold,
  normal,
  reverse,
  forceLeft,
  breakAfter,
  className,
  as,
  level = "h2",
  dataAos,
  dataAosDelay,
  children,
}) => {
  const Level = level as keyof JSX.IntrinsicElements;
  const classes = clsx(
    "headline",
    className ? className : "",
    as ? `headline--as-${as}` : "",
    {
      "headline--left": forceLeft,
    }
  );

  return (
    <Level className={classes} data-aos={dataAos} data-aos-delay={dataAosDelay}>
      {children ? (
        children
      ) : (
        <>
          {reverse ? (
            <React.Fragment>
              {bold && <span className={`headline__bold`}>{bold}</span>}
              {breakAfter ? <br /> : " "}
              {normal && <span className="headline__normal">{normal}</span>}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {normal && <span className="headline__normal">{normal}</span>}
              {breakAfter ? <br /> : " "}
              {bold && <span className="headline__bold">{bold}</span>}
            </React.Fragment>
          )}
        </>
      )}
    </Level>
  );
};
